/**
 * MODULE: _shared/frontend-shell/src/layout/shellNavActive.ts
 * PURPOSE: Sidebar active-state matching for AppLayout — `/crm` matches only `/crm` and `/crm/*`, not `/crm-…` prefixes
 * DEPENDENCIES: None (pure string helpers)
 * PUBLIC_API: isShellNavItemActive
 * SIDE_EFFECTS: None
 * AGENT_SAFETY: SAFE
 * FILE_SIZE: ~24 / 150
 * RECENT: 2026-07-01 [2.2.1475] — Match on the path only, ignoring any query string on the item path (e.g. `/sales-profile?tab=products` for the Define Your Solutions nav item).
 * RECENT_PRIOR: 2026-05-01 [2.2.778] — **`/crm`** active for **`/crm`**, **`/crm/`**, **`/crm/*`** only (not **`/crm-…`**). 2026-04-30 [2.2.728] — Tight **`/crm`** matching + **`AppLayout`** **`data-crm-active`** rail; root **`CHANGELOG` [2.2.728]**
 */

/** True when the shell sidebar item for `itemPath` should render as active for `pathname`. */
export function isShellNavItemActive(itemPath: string, pathname: string): boolean {
  // Match on the path only — nav items may carry a query (e.g. `/sales-profile?tab=products`).
  const base = itemPath.split('?')[0];
  if (base === '/') return pathname === '/';
  // CRM: single sidebar link; highlight for module home and any nested `/crm/*` (not `/crm-…` prefixes).
  if (base === '/crm') {
    return pathname === '/crm' || pathname === '/crm/' || pathname.startsWith('/crm/');
  }
  return pathname.startsWith(base);
}
